<template>
    <v-form lazy-validation v-model="valid" ref="form" @submit="handleEnterKey">
        <v-layout row justify-center>
          <v-flex xs10>
            <v-text-field
              :type="show ? 'text' : 'password'"
              v-model="pin"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              placeholder="****"
              outline
              counter="4"
              single-line
              hide-details
              :color="color"
              class="centered-input display-1 font-weight-black"
              browser-autocomplete="off"
              required
              @click:append="show = !show"
              :rules="[
                      v => {
                          if (v) {
                          return v.length && v.length == 4 || ''
                          } else {
                          return false
                          }
                      }
                      ]"
              mask="NNNN"
            />
          </v-flex>
          <v-layout row justify-center :class="`mt-${loading ? 2 : 1}`">
            <v-btn
              v-if="!loading"
              icon
              :color="color"
              @click="autenticar"
              @keyup.enter="autenticar"
            >
              <v-icon>arrow_forward</v-icon>
            </v-btn>
            <v-progress-circular
                v-else
                indeterminate
                :color="color"
            ></v-progress-circular>
          </v-layout>
        </v-layout>
      <h3 class="error--text text-xs-center mt-1" v-if="textError">Não foi possível autenticar</h3>
    </v-form>
</template>

<script>
export default {
  props: ['frentista', 'cor'],
  data () {
    return {
      show: false,
      valid: false,
      pin: '',
      textError: '',
      color: 'primary'
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    frentistaLogado () {
      return this.$store.getters.frentista
    }
  },
  beforeMount () {
    if (this.cor) {
      this.color = this.cor
    }
  },
  methods: {
    handleEnterKey (event) {
      event.preventDefault()
      this.autenticar()
    },
    autenticar () {
      if (this.pin && this.pin !== '') {
        this.$store.dispatch('autenticarPin', {
          pin: this.pin,
          id: this.frentista.id_frentista
        }).then(() => {
          this.pin = ''
          this.show = false
          this.$emit('autenticado')
        }).catch(() => {
          this.textError = 'PIN incorreto'
          setInterval(() => {
            this.textError = ''
          }, 3000)
        })
      }
    }
  }
}
</script>
